import { render, staticRenderFns } from "./ChatbotAssistant.vue?vue&type=template&id=77731a2a&scoped=true"
import script from "./ChatbotAssistant.vue?vue&type=script&lang=js"
export * from "./ChatbotAssistant.vue?vue&type=script&lang=js"
import style0 from "./ChatbotAssistant.vue?vue&type=style&index=0&id=77731a2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77731a2a",
  null
  
)

export default component.exports